import i18next from 'i18next';

import * as yup from 'yup';

import {PackageTypes} from 'types/gtins';

export const productsSchema = yup
    .array()
    .of(
        yup
            .object({
                gtin: yup.string().required(`${i18next.t('components.form.required')}: GTIN`),
                quantity: yup
                    .number()
                    .typeError(
                        `${i18next.t('components.form.wrong')} ${i18next.t(
                            'pages.orders.form.quantity',
                        )}`,
                    )
                    .positive(
                        `${i18next.t('components.form.wrong')} ${i18next.t(
                            'pages.orders.form.quantity',
                        )}: ${'${value}'}`,
                    )
                    .integer(
                        `${i18next.t('components.form.wrong')} ${i18next.t(
                            'pages.orders.form.quantity',
                        )}: ${'${value}'}`,
                    )
                    .max(
                        10000,
                        `${i18next.t('components.form.wrong')} ${i18next.t(
                            'pages.orders.form.quantity',
                        )}: ${'${value}'}`,
                    )
                    .required(
                        `${i18next.t('components.form.required')}: ${i18next.t(
                            'pages.orders.form.quantity',
                        )}`,
                    ),
                type: yup
                    .string()
                    .oneOf(
                        // ['UNIT', 'GROUP'],
                        Object.keys(PackageTypes),
                        `${i18next.t('components.form.wrong')} ${i18next.t(
                            'pages.orders.form.type',
                        )}: ${'${value}'}`,
                    )
                    .required(
                        `${i18next.t('components.form.required')}: ${i18next.t(
                            'pages.orders.form.type',
                        )}`,
                    ),
            })
            // @ts-ignore
            .uniqueProperty('gtin', ' '),
    )
    .min(1, `${i18next.t('components.form.min')} 1`)
    .max(10, `${i18next.t('components.form.max')} 10`);

const gtinOptionSchema = yup
    .object({
        value: yup.string().required(),
        label: yup.string().required(),
        meta: yup.object({
            productVersionId: yup
                .string()
                .nullable()
                .default(''),
            productName: yup
                .string()
                .nullable()
                .default(''),
            productGroupCode: yup
                .string()
                .nullable()
                .default(''),
            type: yup
                .mixed<keyof typeof PackageTypes>()
                .oneOf(Object.keys(PackageTypes) as Array<keyof typeof PackageTypes>)
                .required(),
        }),
    })
    .nullable();

export type QuantityValidationContext = {
    balance?: number;
    codesLeft?: number;
};

export const productsSchemaNew = yup.object({
    gtin: gtinOptionSchema.required('pages.orders.form.errors.requiredGtin'),

    quantity: yup
        .number()
        .transform((value, originalValue) =>
            originalValue === '' || originalValue === null ? null : value,
        )
        .nullable()
        .typeError('pages.orders.form.errors.quantityInteger')
        .positive('pages.orders.form.errors.quantity')
        .integer('pages.orders.form.errors.quantityInteger')
        .max(10000, 'pages.orders.form.errors.quantityMax10000')
        .test(
            'quantity-max-balance',
            'pages.orders.form.errors.quantityMaxBalance',
            function checkAgainstBalance(value) {
                const {balance} = (this.options.context ?? {}) as QuantityValidationContext;
                if (value == null || balance == null) return true;
                return value <= balance;
            },
        )
        .test(
            'quantity-max-codes-left',
            'pages.orders.form.errors.quantityMaxCodesLeft',
            function checkAgainstCodesLeft(value) {
                const {codesLeft} = (this.options.context ?? {}) as QuantityValidationContext;
                if (value == null || codesLeft == null) return true;
                return value <= codesLeft;
            },
        )
        .required('pages.orders.form.errors.requiredQuantity'),
});
